export default "__VITE_ASSET__PpaiMmnE__"